import {Component, EventEmitter, Input, Output} from '@angular/core';
import {JobsService} from '../../jobs/jobs.service';
import { IUserJob } from 'app/scheduler/core/IUserJob';

@Component({
    selector: 'user-jobs-list',
    templateUrl: 'user-jobs-list.component.html',
    styleUrls: ['user-jobs-list.component.scss']
})
export class UserJobsListComponent {
  @Input() userJobs: Array<IUserJob>;
  @Output() onSetUserJob = new EventEmitter<IUserJob>();

  public searchValue: string;
  public selectedJob: IUserJob;

  constructor(private _jobsService: JobsService) {

  }
  public setCurrentJob(job: IUserJob) {
    this.selectedJob = job;
    this.onSetUserJob.emit(job);
  }
}
